import { render } from "./VerProveedores.vue?vue&type=template&id=ae0ea296"
import script from "./VerProveedores.vue?vue&type=script&lang=js"
export * from "./VerProveedores.vue?vue&type=script&lang=js"

import "./VerProveedores.vue?vue&type=style&index=0&id=ae0ea296&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__